var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.matches.length > 0)?_c('div',{staticClass:"SC-split__col"},[_c('div',{staticClass:"Results-matches"},_vm._l((_vm.matches),function(match){return _c('score-card',{key:match.id,attrs:{"match":match,"flagPath":_vm.flagPath,"detail":_vm.detail,"mode":"live","data-id":match.id,"ticket":_vm.ticket}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }